<template>
  <div>
    <div class="gradient">
      <div class="container">
        <div class="row" style="color: white">
          <div class="d-block d-sm-none col-12">
            <img src="../assets/page_sms_header.png" alt="" class="img-fluid p-5 mx-auto d-block" width="90%">
          </div>
          <div class="col-12 col-lg-5" style="margin-top: auto; margin-bottom: auto">
            <h1 class="text-center">+SMS</h1>
            <p class="text-justify">
              Es una herramienta que nos permite enviar mensajes ilimitados de una manera masiva, fácil e intuitiva.
            </p>
            <p class="text-justify mb-5">
              Envía tus SMS, masivos o personalizados como más te convenga, de la forma que tú lo requieras.
            </p>
          </div>
          <div class="col-7 d-none d-sm-block">
            <img src="../assets/page_sms_header.png" alt="" class="img-fluid p-5 mx-auto d-block" width="90%">
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mb-5" style="position: relative; top:-15px">
        <div class="col-lg-3 col-hover px-0" v-for="card in cards">
          <div :style="`height: 30px; background-color: ${card.color}`"></div>
          <h3 class="text-center px-5 my-3" style="height: 90px;">{{card.titulo}}</h3>
          <p class="text-justify px-4">{{card.texto}}</p>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 col-lg-6" style="margin-top: auto; margin-bottom: auto;">
          <img class="d-none d-sm-block mx-auto" src="../assets/page_sms_image.png" height="200px"
               alt="First slide">
          <img class="d-block d-sm-none mx-auto mb-3" src="../assets/page_sms_image.png" height="150px"
               alt="First slide">
        </div>
        <div class="col-12 col-lg-6 px-5">
          <h3>+ SMS</h3>
          <p>
            Generamos estadísticas de entrega por cada número de teléfono que elijas enviar un SMS.
          </p>
          <p>
            Consulta el histórico de tus mensajes enviados.
          </p>
          <p>
            Conoce el status de cada SMS que envías.
          </p>
          <p>
            Comienza a realizar tus campañas, invita a tus clientes, genera el impacto que necesitas para elevar tus
            ingresos.
          </p>
        </div>
      </div>
      <div class="row justify-content-center mb-4">
        <div class="col-8 col-lg-3">
          <a class=" btn  text-capitalize z-depth-0  py-1" style="color: white !important; background-color: #00A492 !important;" @click="to('Landing')" href="#contact">
            <p class="text-truncate ml-auto mr-auto my-1">Solicitar Demo</p>
          </a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SMS",
    data() {
      return {
        cards: [{
          color: `#00A492`,
          titulo: `Disponible`,
          texto: `Este servicio es apto para cualquier tipo de negocio o industria que busque colocar información con sus clientes o provocar un impacto masivo de información. `
        }, {
          color: `#008DA3`,
          titulo: `Mide tu base de datos`,
          texto: `Te decimos si tus SMS están llegando a tus clientes, y poder concluir si los números siguen siendo utilizados o simplemente están apagados.`
        }, {
          color: `#0064A3`,
          titulo: `Aumenta tus ingresos e impacto`,
          texto: `Crea y programa campañas para tus clientes.
                  Envía SMS a todos tus números, incentiva recargas y promociones con la frecuencia que desees.`
        }, {
          color: `#2F395D`,
          titulo: `Haz realidad tu estrategia`,
          texto: `Completa tus estrategias de calidad, crea gran impacto en tus clientes y sobre todo, genera más ingresos con campañas frecuentes y precisas.`
        }]
      }
    },
    methods:{
      to(route){
        this.$router.push({name:route})
      }
    }
  }
</script>

<style scoped>

  .gradient {
    background: rgba(0, 141, 163, 1);
    background: -moz-linear-gradient(left, rgba(0, 141, 163, 1) 0%, rgba(0, 164, 145, 1) 100%);
    background: -webkit-gradient(left top, right top, color-stop(0%, rgba(0, 141, 163, 1)), color-stop(100%, rgba(0, 164, 145, 1)));
    background: -webkit-linear-gradient(left, rgba(0, 141, 163, 1) 0%, rgba(0, 164, 145, 1) 100%);
    background: -o-linear-gradient(left, rgba(0, 141, 163, 1) 0%, rgba(0, 164, 145, 1) 100%);
    background: -ms-linear-gradient(left, rgba(0, 141, 163, 1) 0%, rgba(0, 164, 145, 1) 100%);
    background: linear-gradient(to right, rgba(0, 141, 163, 1) 0%, rgba(0, 164, 145, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#008da3', endColorstr='#00a491', GradientType=1);
  }

  .col-hover:hover {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .2), 0 6px 7px 0 rgba(0, 0, 0, .7) !important;
  }

  li {
    color: #00A492;
  }

  span {
    color: #00A492;
  }

  .carousel .carousel-indicators li {
    background-color: #00A492;
    width: 2.3rem;
    height: .7rem;
    border-radius: .9rem;
  }

  .btn{
    background-color: white;
    border-radius:25px!important;
    width:100%!important;
  }
</style>
